import { render, staticRenderFns } from "./ElectronicDocumentList.vue?vue&type=template&id=5f821fe0"
import script from "./ElectronicDocumentList.vue?vue&type=script&lang=js"
export * from "./ElectronicDocumentList.vue?vue&type=script&lang=js"
import style0 from "./ElectronicDocumentList.vue?vue&type=style&index=0&id=5f821fe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports